export function accessCodeResultMessage(result) {
    if (result.accessMode === 'extend') {
        const dates = (result.extensions || []).map(e => `${e.packId}: ${new Date(e.expiresAt).toLocaleString('en-GB', { timeZone: 'Asia/Hong_Kong' })} HKT`);
        return `Access extended without replacing your previous term. ${dates.join('; ')}. Check Account for current access. Normal AI limits still apply.`;
    }
    return `Access unlocked until ${new Date(result.expiresAt).toLocaleString()}. Your packs are ready in this Library.`;
}

export function accessCodeErrorMessage(error) {
    if (['functions/failed-precondition', 'failed-precondition'].includes(error?.code)
        && ['access_extension_on_hold', 'access_extension_payment_pending'].includes(error?.details?.reason)) {
        return 'Your extension is paused. Your existing access is unchanged and this code has not been used. Keep the code. If a payment is in progress, complete it normally, then try this same code again. If the issue continues, you can request help.';
    }
    return (error?.message || 'Unable to redeem this code.') + (['functions/deadline-exceeded', 'functions/unavailable', 'functions/internal'].includes(error?.code)
        ? ' The result may be unknown. Check Account before retrying the same code; do not use another campaign to retry.' : '');
}
